import React, { useEffect, useRef, useState } from 'react';
import "./productspage.css";
import bgVideo from "./productspagevideo.mp4";
import bgVideoM from "./productspagevideomobile.mp4";
// import bgVideo2 from "./productspagevideoblur.mp4";
import alohaLogo from "../../assets/aloha-logo.png"
import veriusLogo from "../../assets/verius-logo.png";
import pdiLogo from "../../assets/pdi-logo.png"
import pdiSocialLogo from "../../assets/pdi-social-logo.png"
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ProductsPage = () => {
    const { t, changeLanguage } = useLanguage();
    const topRef = useRef();
    const bottomRef = useRef();
    const [isTopVisible, setIsTopVisible] = useState(false);
    const [isBottomVisible, setIsBottomVisible] = useState(false);


    useEffect(() => {
        const topObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsTopVisible(true);
                    topObserver.unobserve(entry.target);
                }
            });
        });

        const bottomObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsBottomVisible(true);
                    bottomObserver.unobserve(entry.target);
                }
            });
        });

        if (topRef.current) {
            topObserver.observe(topRef.current);
        }

        if (bottomRef.current) {
            bottomObserver.observe(bottomRef.current);
        }

        return () => {
            if (topRef.current) {
                topObserver.unobserve(topRef.current);
            }
            if (bottomRef.current) {
                bottomObserver.unobserve(bottomRef.current);
            }
        };
    }, []);

    const [showMore, setShowMore] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };

    const [showMore2, setShowMore2] = useState(false);

    const toggleShowMore2 = () => {
        setShowMore2(!showMore2);
    };

    return (
        <div className="products-page-container">



            <div className={`products-page-top-container ${isTopVisible ? 'fade-in' : ''}`} ref={topRef}>

                <div class="products-page-video-container products-video-web">
                    <video class="productspage-video" src={bgVideo} autoPlay muted loop playsInline></video>
                </div>

                <div class="products-page-video-container products-video-mobile md:hidden">
                    <video class="productspage-video" src={bgVideoM} autoPlay muted loop playsInline></video>
                </div>

                <h1 className="products-page-title1 mb-8">{t("products")}</h1>

            </div>

            <div className={`products-page-bottom-container ${isBottomVisible ? 'fade-in' : ''}`} ref={bottomRef}>
                <div className='products-page-card'>
                    <h3 className='products-card-title1'>PDI (Private Documents Intelligence)</h3>
                    <div className='md:flex gap-5 mt-4'>
                        <img className='products-page-logo' src={pdiLogo} alt="PDI Logo" />

                        <div>
                            <p className="products-card-text">{t('products-card1-text1')}</p>
                            <p className="products-card-text">{t('products-card1-text2')}</p>

                            <div className={`products-card-text collapsible-content ${showMore ? 'expanded' : ''}`}>

                                <b>{t('products-features')}:</b>
                                <li>{t('products-card1-features1')}</li>
                                <li>{t('products-card1-features2')}</li>
                                <li>{t('products-card1-features3')}</li>
                                <li>{t('products-card1-features4')}</li>
                            </div>

                            <button className="show-more-button" onClick={toggleShowMore}>
                                {showMore ? t('hide') : t('products-features')}
                            </button>
                        </div>
                    </div>
                </div>

                {/* <div className='products-page-card'>
                    <h3 className='products-card-title1'>PDI Social</h3>
                    <div className='md:flex gap-5 mt-4'>
                        <img className='products-page-logo' src={pdiSocialLogo} alt="PDI Logo" />
                        <div>
                            <p className='products-card-text'>PDI Social ürünümüz kapsamında geliştirilmiş olan chatbot, duygu durum analizi ve dinamik yönlendirme yeteneklerine sahip, kullanıcıları doğru insanlarla buluşturarak destek alabilecekleri bir platform sunan yenilikçi bir yapay zeka çözümüdür.</p>
                            <div className={`products-card-text collapsible-content ${showMore2 ? 'expanded' : ''}`}>    
                                    <b>Ürün Özellikleri:</b>
                                    <li className='mt-2'>Duygu Durumu Analizi: Kullanıcıların yazılı ifadelerindeki duygusal tonları algılayarak bireysel ihtiyaçlarına uygun destek sağlama.</li>
                                    <li>Dinamik Yönlendirme: Kullanıcının hissettiği duygular ve ihtiyacına göre uygun bir canlı dinleyiciye veya destek kaynağına bağlanma.</li>
                                    <li>Anonimlik ve Gizlilik: Kullanıcı verilerini anonimleştiren ve KVKK uyumlu veri işleme yöntemleriyle güvenli bir deneyim sunar.</li>
                                    <li>Türkçe Doğal Dil İşleme: Türkçe sohbetlere özel optimize edilmiş dil modeli sayesinde kullanıcılar, doğal ve akıcı bir iletişim deneyimi yaşar.</li>
                                    <li>Modüler ve Geliştirilebilir Mimari: Çeşitli sektörler ve ihtiyaçlara göre kolayca özelleştirilebilir bir altyapıya sahiptir.</li>
                                    
                            </div>
                            <button className="show-more-button" onClick={toggleShowMore2}>
                                {showMore2 ? 'Gizle' : 'Ürün Özellikleri'}
                            </button>
                        </div>
                    </div>
                </div> */}

                <Link id='products-page-link' className="navbar-try-link my-8 mb-16" to="/contact">{t('products-info')}</Link>


            </div>

        </div>
    )
}

export default ProductsPage
